export default __webpack_public_path__ + "7bc771f6256fc38f69fadf4ced564992.svg";